import React, { useContext } from "react";
import { useState } from "react";
import "./new.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import { useNavigate } from "react-router-dom";
import Loader from "../../assets/img/loader.gif";
import { DataContext } from "../../context/DataContext";

//let num = 0;
const TableComponent = ({
  // userType,
  filteredUsers,
  bulkAssignId,
  setBulkAssignId,
  handleSetEditLead,
  setModalOpen,
  setAssignedLeadId,
  setStatusModalOpen,
  setNewStatusLeadId,
  setStageStatus,
  handleLeadStatus,
  handleWonLead,
  setLeadId,
  handlePageChange,
  handlePageSize,
  totalPages,
  currentPage,
}) => {
  const [loader, setLoader] = useState(false);
  const result = useContext(DataContext);

  // console.log(handleFilterLeads);
  const loadcontent = (id) => {
    navigate(`/DatelsLeads/${id}`);
  };

  const handleLoader = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  };
  //console.log(userType);
  const navigate = useNavigate();
  //console.log("Table", num++);

  const capitalizeFirstLetterOfEachWord = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const handleBulkSelect = (e) => {
    let newArr = [];
    const allLeadsCheck = document.getElementsByClassName("selectLead");
    if (e.target.checked) {
      newArr = filteredUsers.map((user) => user.id);
      setBulkAssignId(newArr);
      for (let i = 0; i < allLeadsCheck.length; i++) {
        allLeadsCheck[i].checked = true;
      }
    } else {
      setBulkAssignId([]);
      for (let i = 0; i < allLeadsCheck.length; i++) {
        allLeadsCheck[i].checked = false;
      }
    }
  };
  //  console.log(bulkAssignId);
  const handleCheckboxChange = (e, userId) => {
    let newArray = [...bulkAssignId];
    if (e.target.checked) {
      newArray.push(userId);
      setBulkAssignId(newArray);
    } else {
      newArray = newArray.filter((data) => data !== userId);
      setBulkAssignId(newArray);
    }
  };
  //  console.log(result.employeeData);
  console.log(filteredUsers);
  return (
    <div className="bg-white m-3 rounded-3 p-4">
      {true ? (
        <div className="table-responsive">
          <table className="table table-striped table-bordered text-nowrap mb-0">
            <thead>
              <tr>
                {result?.employeeData?.userType === "1" && (
                  <th>
                    <input
                      type="checkbox"
                      id="bulkSelect"
                      checked={
                        bulkAssignId.length === filteredUsers.length &&
                        filteredUsers.length > 0
                      } // ✅ checked when all are selected
                      ref={(el) => {
                        if (el) {
                          el.indeterminate =
                            bulkAssignId.length > 0 &&
                            bulkAssignId.length < filteredUsers.length; // ✅ indeterminate state
                        }
                      }}
                      onChange={handleBulkSelect}
                    />
                  </th>
                )}

                <th>ID</th>
                <th>SOURCE</th>
                <th>Assigned To</th>
                <th>CLIENT</th>
                <th>CLIENT INFO</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr key={user.id}>
                  {result?.employeeData?.userType === "1" && (
                    <td className="p-4">
                      <input
                        type="checkbox"
                        className="selectLead"
                        checked={bulkAssignId.includes(user.id)} // ✅ controlled by state
                        onChange={(e) => handleCheckboxChange(e, user.id)}
                      />
                    </td>
                  )}

                  <td>
                    <p style={{ marginBottom: "6px" }}>
                      LD-<b>{user.id}</b>
                    </p>
                  </td>
                  <td>
                    <p className="mb-0">
                      Source: <b>{user.leadSource}</b>
                      {/* <br /> */} | Status:{" "}
                      <b>
                        {user.masterStatus?.charAt(0).toUpperCase() +
                          user.masterStatus?.slice(1)}
                      </b>
                      <br />
                      Stage:{" "}
                      <b>
                        {user.status?.charAt(0).toUpperCase() +
                          user.status?.slice(1)}
                      </b>
                      | Pipeline:{" "}
                      <b>
                        {capitalizeFirstLetterOfEachWord(user.leadPipeline)}
                      </b>
                      <br />
                      Company ID: <b>{user.companyId}</b> | KYC:{" "}
                      <b>{user.isKycDone}</b>
                      <br /> Added On:{" "}
                      <b>
                        {new Date(user.createdAt).toISOString().slice(0, 10)}
                      </b>
                    </p>
                  </td>
                  <td>{user.assignedTo && <p>{user.assignedTo}</p>}</td>
                  <td>
                    <p className="mb-0">
                      {user.primaryContactName?.charAt(0).toUpperCase() +
                        user.primaryContactName?.slice(1)}
                      <br />
                      Email: <b>{user.emailId}</b>
                      <br />
                      Phone: <b>{user.mobileNumber}</b>
                      <br />
                      Account Type: <b>{user.accountType || "n/a"}</b>| Lead
                      Type: <b>{user.leadType || "n/a"}</b>
                    </p>
                  </td>
                  <td>
                    <p className="mb-0">
                      Company:{" "}
                      <b>{capitalizeFirstLetterOfEachWord(user.companyName)}</b>
                      | Designation:{" "}
                      <b>
                        {capitalizeFirstLetterOfEachWord(
                          user.primaryContactDesignation
                        )}
                      </b>
                      <br />
                      Business Category: <b>{user.businessCategory}</b> |
                      Current Shipping Partner:{" "}
                      <b>{user.currentShippingPartner}</b>
                      <br />
                      Shipment Potential: <b>{user.shipmentPotential}</b> | Min
                      ES
                      <b>{user.minimumExpectedShipmentToFship}</b>
                      <br />
                      Client Persona: <b>{user.clientPersona}</b> | UTM:{" "}
                      <b>{`${user.utmSource}-${user.utmMedium}-${user.utmCampaign}-${user.utmTerm}-${user.utmContent}`}</b>
                    </p>
                  </td>

                  <td>
                    {/* Row 1 */}
                    <div className="d-flex justify-content-between mb-1">
                      <a
                        className="btn ripple btn-warning btn-xs w-49"
                        onClick={() => loadcontent(user.id)}
                        style={{ color: "#fff" }}
                      >
                        Activity
                      </a>
                      <a
                        className="btn ripple btn-danger btn-xs w-49"
                        onClick={() => navigate(`/lead/contacts/${user.id}`)}
                        style={{ color: "#fff" }}
                      >
                        Contacts
                      </a>
                    </div>

                    {/* Row 2 */}
                    <div className="d-flex justify-content-between mb-1">
                      <button
                        type="button"
                        className="btn ripple btn-success btn-xs w-49"
                        onClick={handleSetEditLead}
                        data-lead={JSON.stringify(user)}
                      >
                        Edit Lead
                      </button>
                      <button
                        className="btn ripple btn-info btn-xs w-49"
                        onClick={() => {
                          setModalOpen(true);
                          setAssignedLeadId(user.id);
                        }}
                        style={{ color: "#fff" }}
                      >
                        {window.location.href.includes("NewLeads") ||
                        window.location.href.includes("All-leads") ||
                        window.location.href.includes("leads/Open")
                          ? "Assign"
                          : "Open & ReAssign"}
                      </button>
                    </div>

                    {/* Row 3 (Stage + Lead Life Cycle) */}
                    <div className="d-flex justify-content-between mb-1">
                      {(window.location.href.includes("NewLeads") ||
                        window.location.href.includes("All-leads") ||
                        window.location.href.includes("leads/Open")) && (
                        <button
                          className="btn btn-warning btn-xs w-49"
                          onClick={() => {
                            setStatusModalOpen(true);
                            setNewStatusLeadId(user.id);
                            setStageStatus(user?.status.toUpperCase());
                          }}
                          style={{ color: "#fff" }}
                        >
                          Stage
                        </button>
                      )}

                      <button
                        type="button"
                        className="btn ripple btn-secondary btn-xs w-49"
                        onClick={handleLeadStatus}
                        data-lead={JSON.stringify(user)}
                      >
                        Leadlife Cyc.
                      </button>
                    </div>

                    {/* Row 4 (Assign to KAM if applicable) */}
                    {user.masterStatus === "Won" && !user.isCustomer && (
                      <div className="d-flex justify-content-center mb-1">
                        <button
                          type="button"
                          className="btn ripple btn-primary btn-xs w-100"
                          onClick={(e) => {
                            handleWonLead(e);
                            setLeadId(user.id);
                          }}
                          style={{ color: "#fff" }}
                        >
                          Assign to KAM
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filteredUsers.length === 0 && !loader && (
            <div className="text-center row m-5">
              <h1>No Leads Found</h1>
            </div>
          )}
        </div>
      ) : (
        <h1 className="text-center">Loading...</h1>
      )}
      {loader ? (
        <>
          {" "}
          <div className="loading-overlay">
            <img src={Loader} alt="Loading..." />
          </div>
        </>
      ) : (
        <></>
      )}
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex" }}>
          <Select
            defaultValue="20"
            onChange={(value) => {
              handlePageSize(value);
              handleLoader();
            }}
            style={{
              marginTop: "10px",
              height: "20px",
              marginRight: "10px",
            }}
          >
            <Option value="20">20</Option>
            <Option value="50">50</Option>
            <Option value="100">100</Option>
            <Option value="200">200</Option>
            <Option value="500">500</Option>
          </Select>
          <span
            style={{
              marginTop: "16px",
              color: "#808080",
            }}
          >
            Page Size
          </span>
        </div>
        <Stack spacing={2} style={{ marginTop: "20px" }}>
          <Pagination
            count={isNaN(totalPages) ? 0 : totalPages}
            page={currentPage}
            variant="outlined"
            onChange={handlePageChange}
            onClick={() => handleLoader()}
            color="primary"
          />
        </Stack>{" "}
      </div>
    </div>
  );
};

export default TableComponent;
